import Cropper from "react-easy-crop";
import { useState, useCallback } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  headingFonts,
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../../Styles/Styles";

const ImageCropper = ({
  imageSrc,
  setCroppedAreaPixels,
  onCropComplete,
  onClose,
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  // Update cropped area in parent state
  const onCropCompleteHandler = useCallback(
    (_, croppedAreaPixels) => {
      setCroppedAreaPixels(croppedAreaPixels);
    },
    [setCroppedAreaPixels]
  );

  return (
    <Dialog
      open={!!imageSrc}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ "& .MuiDialog-paper": { width: "400px" } }} // Adjust width as needed
    >
      <DialogTitle sx={{ ...headingFonts }}>Crop Image</DialogTitle>
      <DialogContent style={{ height: 300, position: "relative" }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropCompleteHandler} // Store cropped pixels in state
        />
      </DialogContent>
      <DialogActions sx={{ mt: 1, mb: 1 }}>
        <Button
          size="small"
          variant="contained"
          sx={{ ...secondaryButtonStyles }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          sx={{ ...primaryButtonStyles }}
          onClick={onCropComplete}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageCropper;
